import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Observer from "../../utils/observer";
import User from "../../../../services/user";
import { BETS_SEARCH_STATUSES, BETS_STATUS, OUTCOMES_STATUS } from "../../utils/ticket-statuses";
import { Cell, CustomTable, EmptyRecordsMessage, FiltersRow, HCell, HRow, Pagination, Panel, PanelRow, Row } from "../../utils/table-utils";
import { DateHelperFilter, PerPageFilter } from "../../utils/form-utils";
import TicketLogic from "../../utils/ticket-logic";
import CashoutService from "../../../../services/cashout";
import MoneyFormatter from "../../utils/money-formatter";
import OddsFormatter from "../../utils/odds-formatter";

import * as U from "../../desktop-templates/menu-user";
import * as I from "../../utils/icons";
import * as C from "../../desktop-templates/cashout.jsx";
import { AutocashoutLabel, CompactCashoutButton, CondensedCashoutButton, ExtendedCashoutButton, Outcome, StatusBadge, TicketElement } from "../cashout";
import { CashoutOptionsContent } from "../../desktop-components/autocashout-tooltip";
import PageDataFeed from "../../../../services/page-data-feed";
import Ticket from "../../../../services/ticket";
import Config from "../../config.jsx";

import { useHeadlessComponent } from "../../../../utils/component-converter";
import AwrabetBetsHistoryPage, {
    BetsTable as AwrabetBetsTable,
    ExtendedTicketElement as AwrabetExtendedTicketElement
} from "../../../awrabet/mobile-pages/user/menu-bets-history";

export default function BetsHistoryPage(props) {
    const api = useHeadlessComponent(AwrabetBetsHistoryPage, props);
    const { state } = api;

    return <div>
        <div class="overflow-x-auto user-menu-subnav">
            <U.SubTabsContainer>
                {Object.entries(state.statustypes).map(
                    ([key, item]) => <U.Tab selected={key === state.statusfilter} onClick={e => api.changeFilter(key)} >{item.label}</U.Tab>
                )}
            </U.SubTabsContainer>
        </div>
        <div class="user-menu-header main-text-color px-2 py-1 text-base font-bold ml-3 mt-2 capitalize rounded">{state.statustypes[state.statusfilter].description}</div>
        <FiltersRow class="gap-2 p-2 text-sm grid grid-cols-2">
            <DateHelperFilter
                firstChild="col-span-2"
                {...state.dateFilter}
                onInput={(dateFilter) => {
                    api.state.dateFilter = dateFilter;
                    api.setState(api.state);
                }}
            />
            <PerPageFilter
                perPage={state.perPage}
                pageList={[15, 30, 45, 50, 100]}
                onInput={({ perPage }) => {
                    api.state.perPage = perPage;
                    api.setState(api.state);
                }}
            />
            <div class="pt-4">
                <a class="px-4 py-2 w-full flex items-center justify-center gap-2 bg-amber-400 text-black rounded" onClick={e => api.performSearch()}>
                    <Trans>Avvia Ricerca</Trans> <I.SearchIcon class="h-3 inline-block" />
                </a>
            </div>
        </FiltersRow>
        <div class="text-sm mt-3">
            <BetsTable
                {...state.response}
                onIdClick={ticket => TicketLogic.printTicket(ticket)}
                onNavigation={api.changePage}
            />
        </div>
    </div>;
}

export class BetsTable extends AwrabetBetsTable {
    render({ data, onIdClick = null }) {
        return <div class="px-2 py-1">
            <div class="py-1 border-t border-(--main-color)">
                {!this.state.data.length ?
                    <EmptyRecordsMessage />
                    : <Fragment>
                        {this.state.data.map(bet => <div class="shadow mb-1 rounded-lg">
                            <ExtendedTicketElement ticket={CashoutService.normalizeTicket(bet.raw)} onCashout={e => this.loadBets()} />
                        </div>)}
                        {!!this.state.onNavigation && <Pagination
                            pages={this.state.totalpages}
                            currentPage={this.state.page}
                            onNavigation={page => { this.state.onNavigation(page, page * this.state.recordperpage - this.state.recordperpage) }}
                            isLastPage={this.state.totalpages === this.state.page}
                        />}
                    </Fragment>}
            </div>
        </div>;
    }
}

export class ExtendedTicketElement extends AwrabetExtendedTicketElement {
    render({ ticket, onCashout }, { closed, showCashoutOptions }) {
        return <div>
            <TicketHeader onClick={e => this.toggleOpen()}>
                <TicketBaseInfo>
                    <div class="flex items-center justify-between pr-2"><span>{ticket.id}</span> <span class="font-normal">{ticket.live ? <Trans>Live</Trans> : <Trans>Prematch</Trans>}</span></div>
                    <div class="flex items-center justify-between pr-2">
                        <div class="">ID: <span class="font-mono">{ticket.ticketId}</span></div>
                        <div class="inline-block" onClick={e => PageDataFeed.printTicket({ code: ticket.ticketId })}><I.PrinterIcon class="h-3" /></div>
                    </div>
                    <div>{new Date(ticket.date).toLocaleString(undefined, { day: "numeric", month: "numeric", year: "2-digit", hour: "numeric", minute: "numeric" })}</div>
                </TicketBaseInfo>
                <TicketMoneyInfo>
                    <div class="flex items-center justify-between">
                        <span><Trans>Stake</Trans></span>
                        <div class="text-right">{ticket.betAmount.toFixed(2)}</div>
                    </div>

                    <div class="flex items-center justify-between">
                        <span><Trans>Odds</Trans></span>
                        <div class="text-right">{ticket.totOdd.toFixed(2)}</div>
                    </div>

                    <div class="flex items-center justify-between">
                        {this.isPending(ticket)
                            ? <Fragment>
                                <span><Trans>Max Win</Trans></span>
                                <div class="text-right">{ticket.maxWinAmount.toFixed(2)}</div>
                            </Fragment>
                            : <Fragment>
                                <span><Trans>Win</Trans></span>
                                <div class="text-right">{ticket.winAmount.toFixed(2)}</div>
                            </Fragment>}
                    </div>
                </TicketMoneyInfo>
                <TicketStatus>
                    {this.isPending(ticket) ?
                        <div onClick={e => e.stopPropagation()} class="w-full h-full border border-amber-600 text-center flex flex-col items-stretch justify-center font-normal bg-amber-500 text-slate-950 rounded">
                            <CondensedCashoutButton
                                ticket={ticket}
                                cashoutTicketHandler={this.cashoutTicketHandler}
                                cashoutWinAmount={CashoutService.calculateCashoutWin(ticket)}
                                toggleCashoutOptions={this.toggleCashoutOptions}
                            />
                        </div>
                        : <div class="flex items-end justify-end h-full pl-2">
                            <StatusBadge ticket={ticket} />
                        </div>}
                </TicketStatus>
                <div class="absolute top-0 right-0">
                    <I.AngleDown class={"h-4 transition-transform " + (closed ? "rotate-180" : "")} />
                </div>
            </TicketHeader>
            {closed ? null : <C.TicketSelections>
                {ticket.odds.map(outcome => <Outcome outcome={outcome} currentOdds={CashoutService.getUpdatedOdd(outcome.id)} />)}
            </C.TicketSelections>}
            {/* Mostra il tooltip se showCashoutOptions è true */}
            {showCashoutOptions && <div class="bg-white">
                <CashoutOptionsContent
                    row={ticket}
                    ticket={ticket}
                    onClose={() => this.setState({ showCashoutOptions: false })}
                    onAutoCashout={onCashout}
                    onPartialCashout={onCashout}
                />
            </div>}
        </div >
    }
}

export function TicketHeader({ children, onClick }) {
    return <div class="border border-amber-700 bg-amber-400 text-slate-950 flex items-stretch relative text-xs font-semibold pl-0.5" onClick={onClick}>{children}</div>
}
export function TicketBaseInfo({ children }) {
    return <div class="w-1/2">{children}</div>
}
export function TicketMoneyInfo({ children }) {
    return <div class="w-1/4">{children}</div>
}
export function TicketStatus({ children }) {
    return <div class="w-1/4 pr-0.5 pl-2 py-0.5">{children}</div>
}
